import { CommonModule } from '@angular/common';
import { NgModule, NgModuleRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TabsComponent } from './tabs/tabs.component';
import { MenuButtonComponent } from './menu-button/menu-button.component';
import { ActionButtonComponent } from './action-button/action-button.component';
import { ActionConfirmComponent } from './confirm-action/confirm-action.component';
import { SuccessComponent } from './success/success.component';
import { LoadingIndicatorComponent } from './loading/loading-indicator.component';
import { ProgressComponent } from './progress/progress.component';

@NgModule({
  declarations: [TabsComponent, MenuButtonComponent, ActionButtonComponent, SuccessComponent, LoadingIndicatorComponent,ActionConfirmComponent, ProgressComponent],
  exports: [TabsComponent, MenuButtonComponent, ActionButtonComponent, SuccessComponent, LoadingIndicatorComponent,ActionConfirmComponent, ProgressComponent],
  imports: [CommonModule, TranslateModule],
})
export class ComponentsModule {}
